import { compose, curry, prop, reduce, complement, eqProps } from 'ramda';
import { matchPath } from 'react-router';

/**
 * Find the route that match url
 * @param {Array} ROUTES contains list of routes
 * @param {String} url
 * @returns {Object} that contains the route that matches url and the result of match function
 */
export const findRouteThatMatchForRoutes = curry((ROUTES, url) =>
  compose(
    prop(0),
    reduce((acc, route) => {
      const match = matchPath(url, route);
      if (match) {
        return [...acc, { route, match }];
      }
      return acc;
    }, [])
  )(ROUTES)
);

export const locationHasChanged = complement(eqProps('pathname'));
